import React from "react";
import CategoryIcon from "@mui/icons-material/Category";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import AppsIcon from "@mui/icons-material/Apps";
import LineStyleIcon from "@mui/icons-material/LineStyle";
import { useLocation } from "react-router";

const ProductItemPage = () => {
  const location = useLocation();
  const { productItemDetails } = location.state;

  const handleDownloadPdf = () => {
    const dummyPdfUrl = productItemDetails.PdfFile;
    const link = document.createElement("a");
    link.href = dummyPdfUrl;
    link.download = "dummy.pdf";
    link.click();
  };
  return (
    <>
      <div className="flex flex-col items-center gap-4 justify-center mb-10">
        <img
          className="h-32 w-32 bg-white p-2 rounded-full"
          src={productItemDetails.Image1Main}
          alt=""
        />
        <div className="text-2xl pr-4">{productItemDetails.ProductName}</div>
        <button
          type="button"
          className="text-gray-900 hover:text-white border border-gray-800 hover:bg-gray-900 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-gray-600 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-800"
          onClick={handleDownloadPdf}
        >
          DOWNLOAD PDF
        </button>
        <div className="px-80 flex flex-col items-center justify-center">
          <div className="px-4"></div>
          <div className="mt-6 border-t border-gray-400">
            <div className="px-20 grid grid-cols-2 gap-40 mt-5">
              <div className="flex flex-col items-start gap-4">
                <div className="flex items-center gap-2">
                  <div className="text-gray-500 text-xl">
                    <CategoryIcon />
                  </div>
                  <div className="text-md text-gray-500">Category:</div>
                  <div className="text-sm text-gray-800 font-semibold">
                    {productItemDetails.PrdtCategory}
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <div className="text-gray-500 text-xl">
                    <AcUnitIcon />
                  </div>
                  <div className="text-md text-gray-500">Properties:</div>
                  <div className="text-sm text-gray-800 font-semibold">
                    {productItemDetails.Properties}
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <div className="text-gray-500 text-xl">
                    <WorkspacePremiumIcon />
                  </div>
                  <div className="text-md text-gray-500">Certifications:</div>
                  <div className="text-sm text-gray-800 font-semibold">
                    {productItemDetails.Certification}
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-start gap-4">
                <div className="flex items-center gap-2">
                  <div className="text-gray-500 text-xl">
                    <AppsIcon />
                  </div>
                  <div className="text-md text-gray-500">Application:</div>
                  <div className="text-sm text-gray-800 font-semibold">
                    {productItemDetails.Application}
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <div className="text-gray-500 text-xl">
                    <LineStyleIcon />
                  </div>
                  <div className="text-md text-gray-500">Materials:</div>
                  <div className="text-sm text-gray-800 font-semibold">
                    {productItemDetails.Materials}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductItemPage;
